/** TASK-922 — Active Plans copy. Demo is per caller, not a shop-wide switch. */

export const voiceLineModeIntro =
  'This line answers as Autoshops.com for everyone. Demo is only for the phone that enters the code.';

export const voiceLineDemoHelp =
  'Call from the phone number on your profile. On the keypad, enter the last four digits of that phone, then pound, and agree when they are read back. Hang up and call again. That next call is the repair-shop demo for 30 minutes. The same code ends it. Hanging up does not. Everyone else stays on Operations.';
